export const aboutRoutes = {
  path: '/about',
  name: 'About Us',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () => import(/* webpackChunkName: "about" */ './About.vue'),
  meta: {
    title: 'About Us'
  }
};
